<template>
  <default-layout></default-layout>
</template>
<script>
import DefaultLayout from '@/layouts/DefaultLayout.vue';

export default {
  name: 'App',
  components: {
    DefaultLayout,
  },
};
</script>
<style>
body{
  position: relative;
}
  #app {
    min-height: 100vh;
    font-family: 'Varela Round', sans-serif;
    background: var(--site-b);
  }
  h1, h2, h3, h4, h5, h6 {

    font-family: 'VT323', monospace;
  }
  footer, header {
    background-image: radial-gradient( rgba(0,0,0,0) 1px,var(--site-b) 1px );
    background-size: 4px 4px;
    backdrop-filter: brightness(100%) blur(3px);
    background-color: rgba(0, 0, 0, 0) !important;
    position: fixed;
    z-index: 1;
    background-color: transparent;

  }
  ul {
    list-style-type: none;
  }
  a {
    text-decoration: none;
  }
</style>
